import { useMemo } from "react"

import { useMatch, useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterFeature, MapAdapterRoad, useNetworkReferential } from "@l2r-front/l2r-networks"
import { useUrlParams } from "@l2r-front/l2r-utils"

import { APP_DOCUMENT, MODULE_DOCUMENTS, NETWORK_ATTACHMENT, ROAD_ATTACHMENT, SECTION_ATTACHMENT } from "../../constants/modules"
import { LINEAR_LOCATION_END, LINEAR_LOCATION_START } from "../../constants/urlParams"
import { MapAdapterDocumentAttachedDetail } from "../../containers/MapAdapterDocumentAttachedDetail"

import { DocumentValidator } from "../DocumentValidator"

export const DocumentContentRouter = () => {

    const matchSection = useMatch(`:slugId/${APP_DOCUMENT}/${MODULE_DOCUMENTS}/:road/attached/${SECTION_ATTACHMENT}`)
    const road = matchSection?.params?.road || null
    const { getParam } = useUrlParams()

    const params = {
        linear_location_road: decodeURIComponent(road), linear_location_start: getParam(LINEAR_LOCATION_START), linear_location_end: getParam(LINEAR_LOCATION_END),
    }
    const { data: sectionFeature } = useNetworkReferential(params)

    const sectionId = useMemo(() => {
        return sectionFeature?.features?.[0]?.id || null
    }, [sectionFeature])

    const documentRoutes = useMemo(() => {
        return [
            {
                path: `/${MODULE_DOCUMENTS}`,
                element: <>
                    <MapAdapterBoundingBox />
                    <SegmentSelectListener />
                </>,
            },
            {
                path: `/${MODULE_DOCUMENTS}/:road`,
                element: <>
                    <MapAdapterRoad />
                    <DetailSegmentSelectListener />
                </>,
            },
            {
                path: `/${MODULE_DOCUMENTS}/attached/${NETWORK_ATTACHMENT}`,
                element: <MapAdapterBoundingBox />,
            },
            {
                path: `/${MODULE_DOCUMENTS}/:road/attached/${ROAD_ATTACHMENT}`,
                element: <MapAdapterRoad />,
            },
            {
                path: `/${MODULE_DOCUMENTS}/:road/attached/${SECTION_ATTACHMENT}`,
                element: <MapAdapterFeature featureId={sectionId} />,
            },
            {
                path: `/${MODULE_DOCUMENTS}/:road/attached/:attachmentType/:attachmentId`,
                element: <>
                    <DocumentValidator />
                    <MapAdapterDocumentAttachedDetail />
                </>,
            },
            {
                path: `/${MODULE_DOCUMENTS}/:road/*`,
                element: <DocumentValidator />,
            },
        ]
    }, [sectionId])

    return useRoutes(documentRoutes)
}